<div [formGroup]="form">
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="allDocuments" id="cbxAllDocuments">
    <label class="form-check-label" for="cbxAllDocuments">All Documents</label>&nbsp;
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="owner" id="cbxOwner">
    <label class="form-check-label" for="cbxOwner">Owner</label>&nbsp;
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="deeds" id="cbxDeeds">
    <label class="form-check-label" for="cbxDeeds">Deeds</label>
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="discharges" id="cbxDischarges">
    <label class="form-check-label" for="cbxDischarges">Discharges/releases</label>&nbsp;
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="foreclosures" id="cbxForeclosures">
    <label class="form-check-label" for="cbxForeclosures">Foreclosures</label>
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="homestead" id="cbxHomestead">
    <label class="form-check-label" for="cbxHomestead">Homestead documents</label>
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="mortgages" id="cbxMortgages">
    <label class="form-check-label" for="cbxMortgages">Mortgages</label>
  </div>
  <div class="form-check-inline">
    <input type="radio" class="form-check-input" formControlName="group" name="group" value="liensAndMortgages" id="cbxLiensAndMortgages">
    <label class="form-check-label" for="cbxLiensAndMortgages">Liens and mortgages</label>
  </div>
  <div class="help-block">
    <span *ngIf="form.errors?.oneisrequired">Please select at least one</span>
  </div>
</div>

